import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  /**
   * Registers custom SVG icons used by Angular Material `<mat-icon [svgIcon]>`.
   * Call once during app startup.
   */
  registerIcons(): void {
    this.iconRegistry.addSvgIcon(
      'assign_form',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/ewx_icons/assign-form.svg',
      ),
    );
  }
}
